<template>
  <div class="p-3">
    <div class="transaction-status">
      <div>
        <p class="text-ref-no">CN REF NO: {{ transactions.invoiceNo }}</p>
        <p class="text-time d-flex">
          {{
            $moment(transactions.createdTime)
              .add(543, "years")
              .format($formatDateNewFull)
          }}
          สาขา {{ transactions.branchName }}
        </p>
      </div>
      <!-- <div class="detail">
        <p
          :class="[
            'text-status',
            transactions.depositStatus == 1 ? 'text-warning' : 'text-danger',
          ]"
        >
          สถานะการขาย: {{ transactions.depositStatusName }}
        </p>
        <p class="text-saleId">
          <b>#{{ transactions.salesNo }} {{ transactions.salesName }}</b>
        </p>
        <p>
          <b>
            วันนัดรับ :
            {{
              $moment(transactions.pickupDate).format("DD/MM/YYYY (HH:mm:ss)")
            }}</b
          >
        </p>
      </div> -->
    </div>

    <template v-if="!isMobile">
      <div class="m-3">
        <b-row class="mx-0 text-center header-products">
          <b-col cols="1" class="header-products-item">
            <p>จำนวน</p>
            <p>Qty</p>
          </b-col>
          <b-col md="5" class="header-products-item text-left">
            <p>รายละเอียดสินค้า/โปรโมชั่น</p>
            <p>Description/Promotion</p>
          </b-col>

          <b-col class="header-products-item">
            <p>ราคาต่อหน่วย</p>
            <p>Unit Price</p>
          </b-col>
          <b-col class="header-products-item">
            <p>ส่วนลด</p>
            <p>Discount</p>
          </b-col>
        </b-row>
      </div>
      <div class="product-list-container">
        <div class="item-products" v-if="transactions.products.length > 0">
          <b-row
            v-for="(product, index) in transactions.products"
            :key="index"
            class="product-panel mx-0 mb-2 h-100 py-2"
          >
            <b-col
              cols="1"
              class="border-product d-flex justify-content-center align-items-center"
            >
              <p class="my-0">{{ product.quantity }}</p>
            </b-col>
            <b-col md="5" class="pointer">
              <div class="d-flex align-items-center">
                <b-img
                  :src="product.image_url || default_image"
                  alt="product image"
                  class="product-image"
                  @error="handleImageSrc"
                />

                <div>
                  <p>{{ product.barcode }}</p>
                  <p
                    v-if="product.product_group_barcode_detail"
                    class="product-info"
                  >
                    Group Barcode: {{ product.product_group_barcode_detail }}
                    {{ product.gp_rate }}%
                  </p>
                  <p class="product-info">
                    {{ product.name }}

                    <span v-if="product.serial">
                      (Serial: {{ product.serial }})
                    </span>
                  </p>
                  <p
                    class="product-info"
                    v-if="product.article_type == 'ZGOLD'"
                  >
                    น้ำหนัก :
                    <span>{{ product.weight | numeral("0,0.00") }} </span>
                  </p>
                  <p v-if="product.promotion">
                    <span>
                      โปรโมชั่น:
                      {{
                        !product.promotion || product.promotion.length == 0
                          ? "-"
                          : ""
                      }}</span
                    >
                    <span
                      v-for="(promotion, index2) in product.promotion"
                      :key="index2"
                    >
                      {{ promotion.name }} ลด {{ promotion.discount_value }}
                      <template v-if="index2 != product.promotion.length - 1">
                        ,
                      </template>
                    </span>
                  </p>
                </div>
              </div>
            </b-col>

            <b-col
              class="price d-flex justify-content-center align-items-center"
            >
              <div>
                <p>
                  {{ product.sap_price | numeral("0,0.00") }}
                </p>
                <p
                  v-if="product.sap_price != product.price"
                  class="normal-unit-price"
                >
                  {{ product.price | numeral("0,0.00") }}
                </p>
                <p>(ราคา ณ วันที่จอง)</p>
              </div>
            </b-col>

            <b-col
              class="price d-flex justify-content-center align-items-center"
            >
              <p>
                {{
                  (product.sap_price * product.quantity -
                    product.after_discount_price)
                    | numeral("0,0.00")
                }}
              </p>
              <div
                v-if="product.article_type == 'ZGOLD'"
                class="d-flex justify-content-center mt-2"
              >
                <div class="">
                  <b-row class="f-10 p-0">
                    <b-col
                      class="text-right text-nowrap text-primary p-0"
                      cols="7"
                    >
                      มูลค่าทอง
                      <font-awesome-icon
                        :id="`tooltip-gold-variable-${index}`"
                        icon="exclamation-circle"
                        class="pointer icon-exclamation"
                      />
                      <b-tooltip
                        :target="`tooltip-gold-variable-${index}`"
                        placement="left"
                      >
                        ราคาทองประจำวัน ต่อกรัม
                        {{ product.gold_price_per_gram | numeral("0,0.00") }}
                        *
                        {{ product.weight | numeral("0,0.00") }}
                      </b-tooltip>
                    </b-col>

                    <b-col class="text-left">
                      {{
                        (product.after_discount_price - product.cost_vat)
                          | numeral("0,0.00")
                      }}
                    </b-col>
                  </b-row>

                  <b-row class="f-10 p-0">
                    <b-col
                      class="text-right text-nowrap text-primary p-0"
                      cols="7"
                    >
                      ค่าแรงรวม VAT
                      <font-awesome-icon
                        :id="`vat-tooltip-${index}`"
                        icon="exclamation-circle"
                        class="pointer icon-exclamation"
                      />
                      <b-tooltip
                        :target="`vat-tooltip-${index}`"
                        placement="left"
                      >
                        ค่าแรงรวม = ราคาขายสินค้า - มูลค่าทอง
                      </b-tooltip>
                    </b-col>

                    <b-col class="text-left">
                      {{ product.cost_vat | numeral("0,0.00") }}
                    </b-col>
                  </b-row>

                  <b-row class="f-10 p-0">
                    <b-col
                      class="text-right text-nowrap text-primary p-0"
                      cols="7"
                    >
                      ค่าแรงไม่รวม
                    </b-col>

                    <b-col class="text-left">
                      {{ product.cost | numeral("0,0.00") }}
                    </b-col>
                  </b-row>

                  <b-row class="f-10 p-0">
                    <b-col
                      class="text-right text-nowrap text-primary p-0"
                      cols="7"
                      >VAT
                    </b-col>

                    <b-col class="text-left">
                      {{ product.vat | numeral("0,0.00") }}
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-if="transactions.products.length > 0">
        <b-row
          class="mx-0 my-1 p-2 bg-white product-panel"
          v-for="(product, index) in transactions.products"
          :key="index"
        >
          <b-col
            cols="2"
            class="text-center pl-0 pr-0 border-product d-flex align-items-center"
          >
            <p>{{ product.quantity }}</p>
          </b-col>

          <b-col class="px-2 pointer text-general text-nowrap">
            <div class="d-flex align-items-center">
              <b-img
                :src="product.image_url || default_image"
                alt="product image"
                class="product-image"
                @error="handleImageSrc"
              />

              <div>
                <p>{{ product.barcode }}</p>
                <p
                  v-if="product.product_group_barcode_detail"
                  class="product-info"
                >
                  Group Barcode: {{ product.product_group_barcode_detail }}
                  {{ product.gp_rate }}%
                </p>
                <p>
                  {{ product.name }}
                  <span v-if="product.serial">
                    (Serial: {{ product.serial }})
                  </span>
                </p>

                <p>
                  โปรโมชั่น:
                  {{ product.promotionDetail || "-" }}
                </p>
              </div>
            </div>
          </b-col>

          <b-col class="pr-0 pointer text-right">
            <div>
              <p>
                {{ product.sap_price | numeral("0,0.00") }}
              </p>
              <p
                v-if="product.sap_price != product.price"
                class="normal-unit-price"
              >
                {{ product.price | numeral("0,0.00") }}
              </p>
            </div>
          </b-col>
          <b-col cols="3" xl="2" class="price">
            <p v-if="product" class="fs-16">
              {{ product.net_price | numeral("0,0.00") }}
            </p>
          </b-col>
        </b-row>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    transactions: {
      type: Object,
      default: () => ({}),
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style></style>
